import { useEffect, useState } from "react";

export function useDelayedAutoFocus(condition = true) {
  const [delayedAutoFocus, setDelayedAutoFocus] = useState(false);

  useEffect(() => {
    if (condition) {
      const timer = setTimeout(() => {
        setDelayedAutoFocus(true);
      }, 200); // 10ms JS delay + 100ms CSS animation + 90ms buffer
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [condition]);

  return delayedAutoFocus;
}
